import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ConnectorApiPort } from './ports/connector-api.port';
import { AdessoConnectorApiAdapter } from './adapters/adesso-connector-api.adapter';

/**
 * Provides ConnectorApiPort backed by the adesso-connector-api adapter.
 */
export function provideConnectorApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ConnectorApiPort, useClass: AdessoConnectorApiAdapter }
  ]);
}
